import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { MonthYearSelect } from '@/components/form/MonthYearSelect';

import { TEditContributionsForm } from '@/components/page/member-details/ContributionsDetails/types';
import s from './ContributionsDatesInput.module.scss';
import { FormSwitch } from '@/components/form/FormSwitch/FormSwitch';

export const ContributionsDatesInput = () => {
  const {
    watch,
    setValue,
    trigger,
    formState: { errors, dirtyFields, touchedFields },
  } = useFormContext<TEditContributionsForm>();
  const { startDate, endDate, isCurrent } = watch();

  const error0 = errors.startDate;
  const error1 = errors.endDate;

  useEffect(() => {
    if (dirtyFields.isCurrent && errors.endDate) {
      trigger();
    }
  }, [isCurrent, trigger, dirtyFields.isCurrent, errors.endDate]);

  return (
    <div className={s.root}>
      <div className={s.body}>
        <MonthYearSelect
          error={error0?.message}
          isRequired
          label="Start Date"
          value={startDate}
          onChange={(val) => {
            if (val === null) {
              return;
            }

            setValue('startDate', val, { shouldValidate: true, shouldDirty: true });
          }}
        />
        <MonthYearSelect
          isRequired={!isCurrent}
          error={error1?.message}
          label="End Date"
          value={endDate}
          disabled={isCurrent}
          onChange={(val) => {
            if (val === null) {
              return;
            }

            setValue('endDate', val, { shouldValidate: true, shouldDirty: true });
          }}
        />
        <FormSwitch name="isCurrent" label="Present" />
      </div>
    </div>
  );
};
